import Vue from 'vue'
import { endpoints } from './ApiEndpoints'
import {
  Company,
  CompanyGradeReport,
  CompanyManager,
  CompanyManagerGradeReport,
  CompanyRepresentativeReport,
  CompanySummaryReport,
  FinanceInfo,
  InvestmentStatusReport,
  User
} from './Interfaces'

// =======================================================================================================

export function getCompanies () {
  return Vue.axios.get(endpoints.core.company.crud)
}
export function getCompany (slug: Company['slug']) {
  return Vue.axios.get(endpoints.core.company.crud + slug + '/')
}

// =======================================================================================================

export function getCompanyManager (id: CompanyManager['id']) {
  return Vue.axios.get(endpoints.core.companyManager.crud + id + '/')
}

export function postCompanyManager (manager: CompanyManager) {
  return Vue.axios.post(endpoints.core.companyManager.crud, manager)
}

export function putCompanyManager (manager: CompanyManager) {
  return Vue.axios.put(endpoints.core.companyManager.crud + manager.id + '/', manager)
}

export function deleteCompanyManager (id: CompanyManager['id']) {
  return Vue.axios.delete(endpoints.core.companyManager.crud + id + '/')
}

// =======================================================================================================

export function getFinanceInfos (company?: Company['id']) {
  const params: { [key: string]: Company['id'] } = {}
  if (company !== undefined) {
    params.company = company
  }
  const endpoint = endpoints.audit.giamSatTaiChinh.financeInfo
  return Vue.axios.get(endpoint, { params })
}

export function postFinanceInfo (financeInfo: FinanceInfo) {
  const endpoint = endpoints.audit.giamSatTaiChinh.financeInfo
  return Vue.axios.post(endpoint, financeInfo)
}

export function putFinanceInfo (id: FinanceInfo['id'], financeInfo: FinanceInfo) {
  const endpoint = endpoints.audit.giamSatTaiChinh.financeInfo + id + '/'
  return Vue.axios.put(endpoint, financeInfo)
}

export function deleteFinanceInfo (id: FinanceInfo['id']) {
  const endpoint = endpoints.audit.giamSatTaiChinh.financeInfo + id + '/'
  return Vue.axios.delete(endpoint)
}

// =======================================================================================================

export function getInvestmentStatusReport (year?: number) {
  const endpoint = endpoints.audit.giamSatTaiChinh.investmentStatusReport
  return Vue.axios.get(endpoint, { params: { year } })
}

export function postInvestmentStatusReport (data: InvestmentStatusReport) {
  const endpoint = endpoints.audit.giamSatTaiChinh.investmentStatusReport
  return Vue.axios.post(endpoint, data)
}

export function patchInvestmentStatusReport (id: string, data: InvestmentStatusReport) {
  const endpoint = endpoints.audit.giamSatTaiChinh.investmentStatusReport + id + '/'
  return Vue.axios.patch(endpoint, data)
}

export function postBulkInvestmentStatusReport (reportYear: FinanceInfo['year'], companyIds?: Array<Company['id']>) {
  const endpoint = endpoints.audit.giamSatTaiChinh.bulkInvestmentStatusReport
  const data = {
    report_year: reportYear,
    company_ids: companyIds || [],
  }
  return Vue.axios.post(endpoint, data)
}

// =======================================================================================================

export function getCompanyGradeReport (year?: number) {
  const endpoint = endpoints.audit.giamSatTaiChinh.companyGradeReport
  return Vue.axios.get(endpoint, { params: { year } })
}

export function postCompanyGradeReport (data: CompanyGradeReport) {
  const endpoint = endpoints.audit.giamSatTaiChinh.companyGradeReport
  return Vue.axios.post(endpoint, data)
}

export function patchCompanyGradeReport (id: string, data: CompanyGradeReport) {
  const endpoint = endpoints.audit.giamSatTaiChinh.companyGradeReport + id + '/'
  return Vue.axios.patch(endpoint, data)
}

export function postBulkCompanyGradeReport (reportYear: FinanceInfo['year'], companyIds?: Array<Company['id']>) {
  const endpoint = endpoints.audit.giamSatTaiChinh.bulkCompanyGradeReport
  const data = {
    report_year: reportYear,
    company_ids: companyIds || [],
  }
  return Vue.axios.post(endpoint, data)
}

// =======================================================================================================

export function getCompanyManagerGradeReport (year?: number) {
  const endpoint = endpoints.audit.giamSatTaiChinh.companyManagerGradeReport
  return Vue.axios.get(endpoint, { params: { year }})
}

export function postCompanyManagerGradeReport (data: CompanyManagerGradeReport) {
  const endpoint = endpoints.audit.giamSatTaiChinh.companyManagerGradeReport
  return Vue.axios.post(endpoint, data)
}

export function patchCompanyManagerGradeReport (id: string, data: CompanyManagerGradeReport) {
  const endpoint = endpoints.audit.giamSatTaiChinh.companyManagerGradeReport + id + '/'
  return Vue.axios.patch(endpoint, data)
}

export function postBulkCompanyManagerGradeReport (reportYear: FinanceInfo['year'], companyIds?: Array<Company['id']>) {
  const endpoint = endpoints.audit.giamSatTaiChinh.bulkCompanyManagerGradeReport
  const data = {
    report_year: reportYear,
    company_ids: companyIds || [],
  }
  return Vue.axios.post(endpoint, data)
}

// =======================================================================================================

export function getCompanyRepresentativeReport (year?: number) {
  const endpoint = endpoints.audit.danhGiaNDD.companyRepresentativeReport
  return Vue.axios.get(endpoint, { params: { year } })
}

export function postCompanyRepresentativeReport (data: CompanyRepresentativeReport) {
  const endpoint = endpoints.audit.danhGiaNDD.companyRepresentativeReport
  return Vue.axios.post(endpoint, data)
}

export function patchCompanyRepresentativeReport (id: string, data: CompanyRepresentativeReport) {
  const endpoint = endpoints.audit.danhGiaNDD.companyRepresentativeReport + id + '/'
  return Vue.axios.patch(endpoint, data)
}

export function postBulkCompanyRepresentativeReport (reportYear: FinanceInfo['year'], companyIds?: Array<Company['id']>) {
  const endpoint = endpoints.audit.danhGiaNDD.bulkCompanyRepresentativeReport
  const data = {
    report_year: reportYear,
    company_ids: companyIds || [],
  }
  return Vue.axios.post(endpoint, data)
}

// =======================================================================================================

export function getCompanySummaryReport(year?: number) {
  const endpoint = endpoints.audit.summary.companySummaryReport
  return Vue.axios.get(endpoint, { params: { year } })
}

export function postCompanySummaryReport (data: CompanySummaryReport) {
  const endpoint = endpoints.audit.summary.companySummaryReport
  return Vue.axios.post(endpoint, data)
}

export function patchCompanySummaryReport (id: string, data: CompanySummaryReport) {
  const endpoint = endpoints.audit.summary.companySummaryReport + id + '/'
  return Vue.axios.patch(endpoint, data)
}

export function postBulkCompanySummaryReport (reportYear: FinanceInfo['year'], companyIds?: Array<Company['id']>) {
  const endpoint = endpoints.audit.summary.bulkCompanySummaryReport
  const data = {
    report_year: reportYear,
    company_ids: companyIds || [],
  }
  return Vue.axios.post(endpoint, data)
}

// =======================================================================================================

export function getGSTCReportExcel (id: string) {
  const endpoint = endpoints.audit.giamSatTaiChinh.gstcReportExcel + id + '/'
  return Vue.axios.get(endpoint)
}

export function postGSTCReportExcel (reportYear: FinanceInfo['year']) {
  const endpoint = endpoints.audit.giamSatTaiChinh.gstcReportExcel
  const data = { report_year: reportYear }
  return Vue.axios.post(endpoint, data)
}

export function getDGNDDReportExcel (id: string) {
  const endpoint = endpoints.audit.danhGiaNDD.dgnddReportExcel + id + '/'
  return Vue.axios.get(endpoint)
}

export function postDGNDDReportExcel (reportYear: FinanceInfo['year']) {
  const endpoint = endpoints.audit.danhGiaNDD.dgnddReportExcel
  const data = { report_year: reportYear }
  return Vue.axios.post(endpoint, data)
}

export function getSummaryReportExcel (id: string) {
  const endpoint = endpoints.audit.summary.summaryReportExcel + id + '/'
  return Vue.axios.get(endpoint)
}

export function postSummaryReportExcel (reportYear: FinanceInfo['year']) {
  const endpoint = endpoints.audit.summary.summaryReportExcel
  const data = { report_year: reportYear }
  return Vue.axios.post(endpoint, data)
}

// =======================================================================================================

export function downloadGSTCReportExcel (id: string) {
  const endpoint = endpoints.audit.giamSatTaiChinh.gstcReportExcel + id + '/download/'
  return Vue.axios.get(endpoint, {
    responseType: 'blob'
  })
}

export function downloadDGNDDReportExcel (id: string) {
  const endpoint = endpoints.audit.danhGiaNDD.dgnddReportExcel + id + '/download/'
  return Vue.axios.get(endpoint, {
    responseType: 'blob'
  })
}

export function downloadSummaryReportExcel (id: string) {
  const endpoint = endpoints.audit.summary.summaryReportExcel + id + '/download/'
  return Vue.axios.get(endpoint, {
    responseType: 'blob'
  })
}

// =======================================================================================================

export function getRecentGSTCReports () {
  const endpoint = endpoints.audit.giamSatTaiChinh.recentReport
  return Vue.axios.get(endpoint)
}

export function getRecentDGNDDReports () {
  const endpoint = endpoints.audit.danhGiaNDD.recentReport
  return Vue.axios.get(endpoint)
}

export function getRecentSummaryReports () {
  const endpoint = endpoints.audit.summary.recentReport
  return Vue.axios.get(endpoint)
}

// =======================================================================================================

export function getLoginUser () {
  const endpoint = endpoints.user.me
  return Vue.axios.get(endpoint)
}

export function logout () {
  const endpoint = endpoints.user.logout
  return Vue.axios.post(endpoint)
}

export function updateUserInfo (user: User) {
  const endpoint = endpoints.user.me
  return Vue.axios.patch(endpoint, user)
}

export function getUsersForApproval () {
  const endpoint = endpoints.user.permission.list
  return Vue.axios.get(endpoint)
}

export function approveUser (userId: User['id']) {
  const endpoint = endpoints.user.permission.approve.replace('{{ id }}', userId)
  return Vue.axios.post(endpoint)
}

export function denyUser (userId: User['id']) {
  const endpoint = endpoints.user.permission.deny.replace('{{ id }}', userId)
  return Vue.axios.post(endpoint)
}
